<template>
    <div :class="`drag-column scroll-column ${selectedColumnWidth == 3 ? 'column-width-3' : 'column-width-2'}`">
      <div class="card">
        <div class="card-body">
          <div v-if="columnTitle !== 'Submitted'">
            <b-form-select class="float-right w-25" v-model="selectedUnit" @change="selectedUnitChanged"
              :options="unitListWithExtraOption" value-field="UID" text-field="name"></b-form-select>
            <span class="drag-column-header">
              <h4 class="card-title mb-4 pb-1">{{ columnTitle }}</h4>
            </span>
          </div>
          <div v-if="columnTitle === 'Submitted'" class="d-flex justify-content-between">
            <span class="drag-column-header">
              <h4 class="card-title mb-4 pb-1">Submitted</h4>
            </span>
            <div class="d-flex flex-column">
              <div>
                <b-button v-b-toggle.collapse_submitFilter variant="primary"
                  class="remove-view-button-title btn-sm btn-label float-right">
                  <i class="mdi mdi-filter-outline label-icon"></i> Filter
                </b-button>
              </div>
              <div>
                <b-collapse id="collapse_submitFilter"
                  style="z-index: 1010; position: absolute; right: 2rem;" class="mt-1">
                  <div class="row d-flex justify-content-end">
                    <div class="border border-primary rounded-lg"
                      style="background-color: white; min-width: 14rem;">
                      <label class="mx-2 mt-2">WO Status</label>
                      <v-select @input="selectedSubmittedColumnFilterChanged('status')"
                        v-model="selectedSubmittedColumnFilter"
                        :options="[{ label: 'All', value: 'all' }, { label: 'Awaiting Review', value: null }, { label: 'Resubmitted for Review', value: null }, { label: 'Approved', value: true }]"
                        class="mb-3 mx-2" :clearable="false" />
                      <label class="mx-2">WO Sort</label>
                      <v-select @input="selectedSubmittedColumnFilterChanged('shift')"
                        v-model="selectedSubmittedColumnSort"
                        :options="['WO # Asc', 'WO # Desc', 'Unit Asc', 'Unit Desc', 'Date Asc', 'Date Desc']"
                        class="mb-3 mx-2" :clearable="false" />
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
          </div>
          <div class="wo-column-card-container">
            <div v-for="workOrder in workOrders" :key="workOrder.view">
              <div v-if="workOrder.isVisible" class="card task-box mb-0" :style="'cursor:pointer'" @click="populateWorkOrder(workOrder)">
                <div class="card-body">
                    <div :style="'height: 200px'"class="d-flex justify-content-center" v-if="isLoading.includes(workOrder.view)">
                        <spring-spinner :animation-duration="3000" :size="50" :color="'blue'" />
                    </div>
                    <div v-else>
                        <div class="float-right ml-2">
                        <div>
                        <span v-b-tooltip.hover :title="workOrder.repairsComplete.value
                            ? `${workOrder.repairsComplete.name} on ${workOrder.repairsComplete.time ? momentInstance(workOrder.repairsComplete.time).format('lll') : workOrder.repairsComplete.date ? momentInstance(workOrder.repairsComplete.date).format('lll') : null}`
                            : null
                            ">
                            <h5>
                            <b-badge class="badge-shrink" :variant="!workOrder.repairsComplete.value
                                ? workOrder.repairsComplete.value === null
                                ? 'warning'
                                : 'danger'
                                : 'success'
                                ">{{
                                !workOrder.repairsComplete.value
                                    ? workOrder.repairsComplete.value === null
                                    ? 'Repairs Ongoing'
                                    : 'Repairs Incomplete'
                                    : 'Repairs Complete'
                                }}</b-badge>
                            </h5>
                        </span>
                        </div>
                        <div>
                        <h5>
                            <b-badge v-if="workOrder.repairs.length === 0" class="badge-shrink" variant="secondary">No Issues</b-badge>
                            <b-badge v-else class="badge-shrink"
                            :variant="workOrder.documentStatus === false ? 'primary' : workOrder.documentStatus === null ? 'warning' : 'success'">{{
                                workOrder.documentStatus === false ? 'No Documents Required' :
                            workOrder.documentStatus === null ? 'Waiting for Documents' : 'All Documents Received' }}</b-badge>
                        </h5>
                        </div> 
                        <div>
                        <span v-b-tooltip.hover :title="workOrder.repairsApproved.value
                            ? `${workOrder.repairsApproved.name} on ${momentInstance(workOrder.repairsApproved.time).format('lll')}`
                            : null
                            ">
                            <h5>
                            <b-badge class="badge-shrink" :variant="repairsApprovedBadgeLogic(
                                workOrder.repairsApproved,
                                workOrder.changeNotes
                            ).class
                                ">{{
                                repairsApprovedBadgeLogic(
                                    workOrder.repairsApproved,
                                    workOrder.changeNotes
                                ).text
                                }}
                            </b-badge>
                            </h5>
                        </span>
                        </div>
                    </div>
                    <div>
                        <h5 class="font-size-15">
                        <p class="text-dark">{{ workOrder.number }}</p>
                        </h5>
                    </div>
                    <p class="text-muted">{{ momentInstance(workOrder.date).format('ll') }}</p>
                    <div class="d-flex w-100">
                        <p class="text-muted">Unit</p>
                        <h6>
                        <b-badge v-for="unit in workOrder.units" :key="unit" :variant="'primary'" class="ml-2">{{
                            getUpToDateUnitName(unit) !== null ? getUpToDateUnitName(unit) : `` }}</b-badge>
                        </h6>
                    </div>
                    <div v-if="workOrder.generalNotes && workOrder.generalNotes !== ''" style="word-break: break-word;">
                        <p class="text-muted">Note: <span class="font-italic text-wrap">{{workOrder.generalNotes}}</span></p>
                    </div>
                    <div class="team">
                        <p class="wo-card-issues-text" @click.stop="handleShowWorkOrderIssueDetails(workOrder.view)">{{ `${workOrder.repairs.length} Issues` }}
                        <i v-if="workOrder.showIssueDetails" class="mdi mdi-chevron-down mr-2 tableIcons"></i>
                        <i v-else class="mdi mdi-chevron-up mr-2 tableIcons"></i>
                        </p>
                        <ul v-if="workOrder.showIssueDetails" class="list-group list-group-flush">
                        <li class="list-group-item wo-card-issues-dropdown" v-for="(issue) in workOrder.repairs" :key="issue.id">
                            <div class="row text-wrap">
                            <p class="col-6"><span class="font-italic font-weight-bold">Issue:</span> <span v-html="issue.issue ? issue.issue.replace(/\n/g, '<br>') : ''"></span> </p>
                            <p class="col-6"><span class="font-italic font-weight-bold">Repair:</span> <span v-html="issue.repair ? issue.repair.replace(/\n/g, '<br>') : ''"></span></p>
                            </div>
                        </li>
                        </ul>
                    </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

<script>
import moment from 'moment';
import { SpringSpinner } from 'epic-spinners';

export default {
    components: {
        SpringSpinner,
    },
    props: {
        columnTitle: {
            type: String,
            required: true
        },
        selectedUnitDataProp: {
            type: String,
            required: true
        },
        unitListWithExtraOption: {
            type: Array,
            required: true
        },
        allUnits: {
            type: Array,
            required: true
        },
        workOrders: {
            type: Array,
            required: true
        },
        selectedColumnWidth: {
            type: [Number, String],
            required: true
        },
        isLoading: {
            type: Array,
            required: false,
        }
    },
    data() {
        return {
            momentInstance: moment,
            selectedUnit: null,
            selectedSubmittedColumnFilter: { label: 'All', value: 'all' },
            selectedSubmittedColumnSort: 'Date Desc',
        };
    },
    methods: {
        selectedUnitChanged() {
            this.$emit('update-column-unit-filter', this.selectedUnit, this.selectedUnitDataProp);
        },
        selectedSubmittedColumnFilterChanged(filter) {
            const changedFilterValue = filter === 'status' ? this.selectedSubmittedColumnFilter : this.selectedSubmittedColumnSort;
            this.$emit('update-submitted-column-filter', filter, changedFilterValue);
        },
        populateWorkOrder(workOrder) {
            this.$emit('populate-work-order', workOrder);
        },
        handleShowWorkOrderIssueDetails(view) {
            let workOrderColumnDataProperty = null;

            switch(this.columnTitle){
                case 'Waiting to Start':
                workOrderColumnDataProperty = 'notStartedWorkOrders';
                break;
                case 'In Progress':
                workOrderColumnDataProperty = 'inProgressWorkOrders';
                break;
                case 'Waiting for Docs':
                workOrderColumnDataProperty = 'waitingOnDocsWorkOrders';
                break;
                case 'Completed':
                workOrderColumnDataProperty = 'completedWorkOrders';
                break;
                case 'Changes Requested':
                workOrderColumnDataProperty = 'changesRequestedWorkOrders';
                break;
                case 'Submitted':
                workOrderColumnDataProperty = 'submittedWorkOrders';
                break;
                default:
                break;
            }

            this.$emit('handle-show-work-order-issue-details', view, workOrderColumnDataProperty);
        },
        repairsApprovedBadgeLogic: function (repairsApproved, changeNotes) {
            let retValue = {
                class: null,
                text: null,
            };
            if (!repairsApproved.value) {
                //if the repairs are not approved then check if they are waiting
                if (repairsApproved.value === null) {
                    retValue.text = 'Awaiting Review';
                    retValue.class = 'warning';

                    // check if the work order was resubmitted
                    if(changeNotes.length >= 1){
                      retValue.text = 'Resubmitted for Review';
                    }
                } else {
                    //if we aren't waiting, then the repairs are not approved.
                    //if we aren't waiting and there are change notes, then we have requested changes.
                    if (changeNotes.length >= 1) {
                        retValue.text = 'Changes Requested';
                        retValue.class = 'primary';
                    } else {
                        retValue.text = 'Not Submitted';
                        retValue.class = 'danger';
                    }
                }
            } else {
                //repairs are approved.
                retValue.text = 'Approved';
                retValue.class = 'success';
            }

            return retValue;
        },
        getUpToDateUnitName: function (unitUid) {
            let upToDateUnitName = null;
            const unitIndex = this.allUnits.findIndex((x) => x.UID === unitUid);
            if (unitIndex !== -1) {
                upToDateUnitName = this.allUnits[unitIndex].name;
            }
            return upToDateUnitName;
        },
    }
};
</script>

<style></style>